<i18n>
{
    "en":{
        "game_name": "LINE: Disney Tsum Tsum",
        "key_feature": "Key features",
        "feature1": "Auto receive hearts one by one / receive all hearts",
        "feature2": "Auto send hearts to friends",
        "feature3": "Auto play game (with props paid by coins)",
        "feature4": "Auto open boxes",
        "feature5": "Auto unlock Tsum's level",
        "feature6": "Delicate heart trading detail record",
        "feature7": "Download record as excel report",
        "feature8": "Share the beautiful detail report to your friends",
        "feature9": "Auto pilot the game for days or even weeks!",
        "already_trying": "Start playing",
        "apply_free_trial": "Try for FREE",
        "go_simple_tutorial": "Quick start guide",
        "quickGuideURL": "https://tsumtsum.app/en/xrobotmon-tutorial",
        "subscribe": "Subscribe Now"
    },
    "zhHant":{
        "game_name": "LINE: Disney Tsum Tsum",
        "key_feature": "主要特點",
        "feature1": "自動一顆一顆收心/收全部愛心",
        "feature2": "自動送心給朋友",
        "feature3": "自動玩遊戲（可選擇道具）",
        "feature4": "自動開箱子",
        "feature5": "自動解鎖角色等級",
        "feature6": "精美詳細收送心記錄（紀錄朋友有沒有乖乖送心）",
        "feature7": "下載詳細紀錄EXCEL報表",
        "feature8": "分享精美詳細紀錄給朋友",
        "feature9": "放置7天/30天都不用擔心，每天24小時不間斷",
        "already_trying": "開始玩囉",
        "apply_free_trial": "馬上免費試用！",
        "go_simple_tutorial": "簡易使用教學",
        "quickGuideURL": "https://tsumtsum.app/zh/xrobotmon-tutorial",
        "subscribe": "馬上訂閱！"
    },
    "ja":{
        "game_name": "LINE：ディズニー ツムツム",
        "key_feature": "主な機能",
        "feature1": "ハートを1つずつ受け取って自動でお返し、まとめて受け取りも可能",
        "feature2": "友達にハートを自動送信",
        "feature3": "使用するアイテムを選んで自動プレイ",
        "feature4": "BOXを自動で開ける",
        "feature5": "ツムのレベル上限を自動で解放",
        "feature6": "ハート送受信の詳細な記録（お友達が送ってくれたハートの数もわかります）",
        "feature7": "詳細な記録をExcel形式でダウンロード",
        "feature8": "詳細な記録を友達とシェア",
        "feature9": "7日間・30日間ずっと、24時間止まらずに稼働",
        "already_trying": "スタート",
        "apply_free_trial": "無料で試してみる",
        "go_simple_tutorial": "基本的な使い方",
        "quickGuideURL": "https://tsumtsum.app/ja/xrobotmon-tutorial",
        "subscribe": "今すぐ登録する！"
    },
    "ko": {
        "game_name": "라인: 디즈니 썸썸",
        "key_feature": "주요 기능",
        "feature1": "자동으로 하트를 수집",
        "feature2": "자동으로 친구에게 하트 보내기",
        "feature3": "자동으로 게임 시작 (아이템 선택)",
        "feature4": "자동으로 상자 열기",
        "feature5": "자동으로 캐릭터 레벨 잠금 해제",
        "feature6": "자세한 친구와의 하트 교환 내역",
        "feature7": "상세 기록 Excel 다운로드",
        "feature8": "상세 기록을 친구에게 공유",
        "feature9": "24시간 실시간으로 매크로가 작동합니다.",
        "already_trying": "시작하기",
        "apply_free_trial": "무료 체험하기",
        "go_simple_tutorial": "사용방법 알아보기",
        "quickGuideURL": "https://tsumtsum.app/ko/xrobotmon-tutorial",
        "subscribe": "즉시 구독하기"
    }
}
</i18n>
<template>
  <div>
    <v-card class="mx-auto elevation-0 transparent">
      <v-card-title>
        <v-layout row wrap align-center>
          <v-flex xs9>
            <div class="title">{{ $t('game_name') }}</div>
          </v-flex>
          <v-flex xs3>
            <v-avatar tile size="80">
              <GameLogo :imageUrl="tsumLogoUrl" :width="80" :height="80" />
            </v-avatar>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text v-if="!small">
        <v-list dense style="background: none" subheader>
          <v-subheader>{{ $t('key_feature') }}</v-subheader>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon>mdi-numeric-1-box-outline</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>{{ $t('feature1') }}</v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon>mdi-numeric-2-box-outline</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>{{ $t('feature2') }}</v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon>mdi-numeric-3-box-outline</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>{{ $t('feature3') }}</v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon>mdi-numeric-4-box-outline</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>{{ $t('feature4') }}</v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon>mdi-numeric-5-box-outline</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>{{ $t('feature5') }}</v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon>mdi-numeric-6-box-outline</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>{{ $t('feature6') }}</v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon>mdi-numeric-7-box-outline</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>{{ $t('feature7') }}</v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon>mdi-numeric-8-box-outline</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>{{ $t('feature8') }}</v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon>mdi-numeric-9-box-outline</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>{{ $t('feature9') }}</v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card-text>
      <v-card-actions v-if="!small">
        <v-btn color="green lighten-2" block dark outline :href="$t('quickGuideURL')" target="_blank">{{
          $t('go_simple_tutorial')
        }}</v-btn>
      </v-card-actions>
      <v-card-actions v-if="mode === 'trial'">
        <v-btn color="blue lighten-2" block dark @click="getTrial">
          {{ $t('apply_free_trial') }}
        </v-btn>
      </v-card-actions>
      <v-card-actions v-else>
        <v-btn color="blue lighten-2" block dark @click="subscribe">{{ $t('subscribe') }}</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import assetMisc from '../assets/misc';
import GameLogo from '../components/ui/GameLogo.vue';

export default {
  name: 'TsumIntro',
  components: { GameLogo },
  props: {
    mode: {
      type: String,
      default: 'trial', // 'trial' 'subscribe'
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return { tsumLogoUrl: assetMisc.tsumLogoUrl };
  },
  methods: {
    isEmpty(x) {
      return isEmpty(x);
    },
    getTrial() {
      this.$router.push(`/trial/tsum`);
    },
    subscribe() {
      this.$router.push(`/plan/tsum`);
    },
  },
};
</script>
